// extracted by mini-css-extract-plugin
export default {"mCard":"yw-z","image":"zw-z","imageNoBackground":"Aw-z","imageHasCategory":"Bw-z","fullWidth":"Cw-z"};